import { render } from "./ReportsPageTableColumnLabelMono.vue?vue&type=template&id=0d6dcddc&ts=true"
import script from "./ReportsPageTableColumnLabelMono.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnLabelMono.vue?vue&type=script&lang=ts"

import "./ReportsPageTableColumnLabelMono.vue?vue&type=style&index=0&id=0d6dcddc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__